import script from "./DlCarInent.vue?vue&type=script&lang=ts&setup=true"
export * from "./DlCarInent.vue?vue&type=script&lang=ts&setup=true"

import "./DlCarInent.vue?vue&type=style&index=0&id=2aff2c4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aff2c4c"]])

export default __exports__